<template>
  <div class="resultPage">
    <div
      class="resultContent"
      :style="this.hideBroker ? 'height:100vh' : 'height:calc(100vh)'"
    >
      <van-tabs
        v-model="active"
        line-width="16"
        line-height="4"
        color="#FFC600"
        :sticky="true"
      >
        <van-tab title="等额本息">
          <PayCard type="1" :epI="this.epi" :ep="this.ep"></PayCard>
          <PayList type="epi"></PayList>
        </van-tab>
        <van-tab title="等额本金">
          <PayCard type="2" :epI="this.epi" :ep="this.ep"></PayCard>
          <PayList type="ep"></PayList>
        </van-tab>
      </van-tabs>
    </div>
    <div class="brokerBar" v-if="!this.hideBroker">
      <div class="broker-info">
        <div class="imgDiv">
          <img
            class="broker-img"
            :src="
              brokerInfo.brokerimg
                ? brokerInfo.brokerimg
                : 'https://static-official.5i5j.com/offical/cdn/4030d54775de88f325dcf9d8d9e04dea_1692583059094.png'
            "
            @click="brokerDetail"
          />
        </div>
        <div>
          <div class="broker-name">
            <div class="broker-name-text">
              {{ brokerInfo.bname }}
            </div>
            <img
              v-if="brokerInfo.jobimg"
              @click="openJobImg"
              class="id-icon"
              src="https://static-official.5i5j.com/offical/cdn/ee5e405c20634d687cd22b164f49ac7d_1727597721173.png"
            />
            <van-overlay :show="showJob" @click="showJob = false">
              <div class="jobModal" @click.stop>
                <img class="jobImg" :src="brokerInfo.jobimg" />
                <img
                  class="closeImg"
                  @click="showJob = false"
                  src="https://static-official.5i5j.com/offical/cdn/3a265e76a654094dfe12d19e59bc545a_1731983526429.png"
                />
              </div>
            </van-overlay>
          </div>
          <div class="broker-score">
            <img
              v-if="brokerInfo.first_tag"
              class="ij-star-icon"
              src="https://static-official.5i5j.com/offical/cdn/48e5ed906439bb73feabb39dbb630949_1727597918702.png"
            />
            <img
              v-if="brokerInfo.dkscores"
              class="star-icon"
              src="https://static-official.5i5j.com/offical/cdn/bf04dd171c0b20205274e5854e2def34_1727597935621.png"
            />
            <div
              class="broker-score-text"
              v-if="Number(brokerInfo.dkscores) > 0"
            >
              {{ brokerInfo.dkscores }}
            </div>
          </div>
        </div>
      </div>
      <div class="broker-contect">
        <div class="broker-contect-left" @click="callBroker(brokerInfo.phone)">
          <img
            class="broker-phone-icon"
            src="https://static-official.5i5j.com/offical/cdn/6e9effac54085a2aeb2f4a399f2c99b7_1727598690390.png"
          />
        </div>
        <div class="broker-contect-right" @click="toIm(brokerInfo)">
          <img
            class="broker-im-icon"
            src="https://static-official.5i5j.com/offical/cdn/23b26cf74bb0db58b5d387a3e5c75f29_1727598683241.png"
          />
          <div>在线聊</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $http from "../../utils/request";
import PayCard from "./PayCard";
import PayList from "./PayList";
import {
  launchChatActionCallBack,
  goBrokerDetail,
  getWebViewEnv,
} from "../../utils/app-bridge";

import sensors from "@/utils/sensors";
export default {
  components: {
    PayCard,
    PayList,
  },
  data() {
    return {
      active: 2,
      epi: {},
      ep: {},
      columns: [],
      brokerInfo: {},
      showJob: false,
      webViewEnv: getWebViewEnv(),
      sendPrice: 0,
      hideBroker: 0, // 是否隐藏经纪人
    };
  },

  created() {
    const title = {
      business: "商业贷款",
      pubaccu: "公积金贷款",
      composition: "组合贷款",
    };
    document.title = title[this.$route.query.type] || "贷款明细";
    if (this.$route.query.form) {
      const data = JSON.parse(decodeURIComponent(this.$route.query.form));
      $http({
        url: `/appapi/normals/${this.$store.state.location.cityId}/v1/loandetails`,
        method: "post",
        data,
      })
        .then((res) => {
          if (res.msg == "OK") {
            const { epi, ep, broker } = res.data;
            this.epi = epi;
            this.ep = ep;
            this.columns = ep.totalDetail;
            this.brokerInfo = broker;
            this.$store.dispatch("setCalcuRes", res.data);
            localStorage.setItem("calcuRes", JSON.stringify(res.data));
            this.sendPrice =
              this.active == 1
                ? (Number(epI.totalPrincipal) / 10000).toFixed(2)
                : (Number(ep.totalPrincipal) / 10000).toFixed(2);
          }
        })
        .catch((err) => {
          console.log("err--->", err);
        });
    } else {
      this.epi = this.$store.state.calcuRes.epi;
      this.ep = this.$store.state.calcuRes.ep;
      this.columns = this.$store.state.calcuRes.ep.totalDetail;
      this.brokerInfo = this.$store.state.calcuRes.broker;
      this.sendPrice =
        this.active == 1
          ? (
              Number(this.$store.state.calcuRes.epi.totalPrincipal) / 10000
            ).toFixed(2)
          : (
              Number(this.$store.state.calcuRes.ep.totalPrincipal) / 10000
            ).toFixed(2);
    }
    this.hideBroker =
      Number(this.$route.query?.hideBroker) ||
      navigator.userAgent.includes("from=brokerapp") ||
      this.webViewEnv == "WAP";
    console.log("=====>", Number(this.$route.query?.hideBroker));
    console.log(
      "from=brokerapp",
      navigator.userAgent.includes("from=brokerapp")
    );
    console.log(
      'this.webViewEnv == "WAP"',
      this.webViewEnv,
      this.webViewEnv == "WAP"
    );
    console.log(
      "hideBroker",
      this.hideBroker,
      "cityName",
      this.$store.state.location.cityName,
      "cityId",
      this.$store.state.location.cityId
    );
    //结果页曝光
    sensors.track("BuytoolExposure", {
      elementname_var: "结果页",
      page_name: "房贷计算器页",
      city_pvar: this.$store.state.location.cityName,
    });
    // 爱聊曝光
    sensors.track("OnlineExposure", {
      module_var: "房贷计算器",
      buttonname_var: "结果页",
      agentid_var: this.brokerInfo.brokerid,
      elementname_var: `您好，我的贷款预算为${this.sendPrice}万，想咨询一些房贷方面的问题。`,
    });
    // 电话曝光
    sensors.track("TelExposure", {
      module_var: "房贷计算器",
      buttonname_var: "结果页",
      agentid_var: this.brokerInfo?.brokerid,
    });
  },
  methods: {
    openJobImg() {
      this.showJob = true;
    },
    // 打电话
    callBroker(tel) {
      window.location.href = `tel:${tel}`;
      sensors.track("TelConsult", {
        module_var: "房贷计算器",
        buttonname_var: "结果页",
        agentid_var: this.brokerInfo?.brokerid,
      });
    },
    // 跳转爱聊
    toIm(brokerInfo) {
      sensors.track("OnlineConsult", {
        module_var: "房贷计算器",
        buttonname_var: "结果页",
        agentid_var: brokerInfo.brokerid,
        elementname_var: `您好，我的贷款预算为${this.sendPrice}万，想咨询一些房贷方面的问题。`,
      });
      const {
        bname: brokerName,
        phone,
        brokerid: brokerId,
        brokerimg: brokerImg,
      } = brokerInfo || {};
      launchChatActionCallBack({
        brokerName,
        phone,
        brokerId,
        brokerImg,
        cityId: Number(this.$store.state.location.cityId),
        houseInfo: {},
        msg: `您好，我的贷款预算为${this.sendPrice}万，想咨询一些房贷方面的问题。`,
      });
    },
    // 经纪人详情页
    brokerDetail() {
      const { brokerid } = this.brokerInfo || {};
      goBrokerDetail({
        brokerid,
        brokerCityID: this.$store.state.location.cityId,
      });
    },
  },
};
</script>
<style scoped>
.resultPage {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  position: relative;
}
.resultContent {
  overflow-y: scroll;
  padding-bottom: 164px;
}
.brokerBar {
  width: 750px;
  height: 134px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
}
.resultContent /deep/ .van-tabs__line {
  bottom: 42px;
}
.broker-info {
  margin-left: 24px;
  display: flex;
  width: 222px;
}
.imgDiv {
  width: 84px;
  height: 84px;
  margin-right: 8px;
  border-radius: 42px;
  overflow: hidden;
}
.broker-img {
  width: 100%;
  height: auto;
}
.broker-name {
  display: flex;
  margin-top: 10px;
}
.broker-name-text {
  font-weight: 500;
  font-size: 28px;
  color: #333333;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  margin-right: 8px;
}
.id-icon {
  margin-top: 2px;
  width: 32px;
  height: 24px;
}

.broker-score {
  display: flex;
  margin-top: 12px;
}

.ij-star-icon {
  width: 58px;
  height: 24px;
  margin-right: 8px;
}
.star-icon {
  width: 24px;
  height: 24px;
  margin-right: 4px;
}
.broker-score-text {
  font-weight: 500;
  font-size: 24px;
  color: #fc9506;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}

.broker-contect {
  width: 328px;
  display: flex;
  margin-right: 24px;
}

.broker-contect-left {
  width: 100px;
  height: 96px;
  background-image: url("https://static-official.5i5j.com/offical/cdn/af3f82bff79027c5e7e2d47e3e9184e1_1727598676268.png");
  background-size: 100% 100%;
  background-position: center;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.broker-contect-right {
  width: 222px;
  height: 96px;
  background-image: url("https://static-official.5i5j.com/offical/cdn/86451757e94c078599eb2b68cfafdae5_1727598671418.png");
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  align-items: center;
  padding-left: 32px;
  font-weight: 400;
  font-size: 32px;
  color: #ffffff;
  line-height: 32px;
  text-align: right;
  font-style: normal;
}
.broker-im-icon {
  width: 48px;
  height: 48px;
  margin-right: 4px;
}
.broker-phone-icon {
  width: 48px;
  height: 48px;
}
.jobModal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.jobImg {
  width: 416px;
  height: 556px;
}
.closeImg {
  width: 82px;
  height: 82px;
  margin-top: 84px;
}
</style>
